<div class="modal-body vtr-modal-recover-confirm">
	<h1 id="hwscan-recover-title" class="title" role="heading">{{ 'hardwareScan.warning' | translate }}</h1>

	<p id="hwscan-recover-description" class="description" role="text">{{ 'hardwareScan.recoverBadSectors.popup.description' | translate }}</p>

	<div class="row button-row line-separator">
		<vtr-material-button
			linkId="hwscan-rbs-confirm-btn"
			[label]="'hardwareScan.ok' | translate | uppercase"
			[tooltipText] ="'hardwareScan.ok' | translate"
			(buttonClick)="confirmClick()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="hwscan-rbs-confirm-close-btn"
			(clickClose)="onClosing()">
		</vtr-ui-close-button>
	</div>
</div>
